import type { DocNode } from '@atlaskit/adf-schema';

import type { ConfluenceCreatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import type { ConfluencePageCreateCommandProcessor } from '../stream-processors/create-command-processor';

import { type PassThroughCommandProperties } from './types/command-handler-types';
import { StreamingCommandHandler } from './types/streaming-command-handler';

export class CreateCommandHandler extends StreamingCommandHandler<ConfluenceCreatePageCommandProperties> {
	constructor(
		properties: PassThroughCommandProperties,
		private createCommandProcessor: ConfluencePageCreateCommandProcessor,
	) {
		super(properties, 'create');
	}

	async process(params: ConfluenceCreatePageCommandProperties): Promise<void> {
		if (!params.data.adf) {
			return;
		}

		if (!params.isStreamComplete) {
			this.createCommandProcessor.stream(params.data.adf, this.isStreamFinished);
		}
	}

	async finishAction(): Promise<DocNode | undefined> {
		const adfDoc = await this.createCommandProcessor.finish(
			this.properties.onStreamError,
			this.properties.onStreamRepair,
		);

		if (adfDoc) {
			this.properties.editorAPI.core.actions.replaceDocument(adfDoc, {
				addToHistory: false,
				scrollIntoView: false,
			});
		}

		return adfDoc;
	}

	abort(): void {
		this.createCommandProcessor.abort();
	}
}
